import { render, staticRenderFns } from "./NurseAppraisals.vue?vue&type=template&id=0b2d7e07"
import script from "./NurseAppraisals.vue?vue&type=script&lang=js"
export * from "./NurseAppraisals.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports